var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHamburg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "14px",
    viewBox: "0 0 15 14",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.18917 0L13.6967 0C14.3509 0 14.8858 0.534985 14.8858 1.18917C14.8858 1.84335 14.3509 2.37833 13.6967 2.37833L1.18917 2.37833C0.534985 2.37833 0 1.84335 0 1.18917C0 0.534985 0.534985 0 1.18917 0Z",
    id: "Fill-1",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.18917 5.67833L13.6967 5.67833C14.3509 5.67833 14.8858 6.21332 14.8858 6.8675C14.8858 7.52168 14.3509 8.05666 13.6967 8.05666L1.18917 8.05666C0.534985 8.05666 0 7.52168 0 6.8675C0 6.21332 0.534985 5.67833 1.18917 5.67833Z",
    id: "Fill-2",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.18917 11.3567L13.6967 11.3567C14.3509 11.3567 14.8858 11.8916 14.8858 12.5458C14.8858 13.2 14.3509 13.735 13.6967 13.735L1.18917 13.735C0.534985 13.735 0 13.2 0 12.5458C0 11.8916 0.534985 11.3567 1.18917 11.3567Z",
    id: "Fill-3",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburg);
export default __webpack_public_path__ + "static/media/hamburg.51c9d0342ccf006caa1450bd839f353d.svg";
export { ForwardRef as ReactComponent };